import React, { useState, useContext, useEffect } from 'react';
import '../App.css';
import '../assets/CSS/HeroSectionModern.css';
import { Button } from './Button';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { GlobalContext } from '../Context/GlobalContext';
import { UserContext } from '../Context/UserContext';
import { VehicleDataContext } from '../Context/VehicleDataContext';
import SearchContext from '../Context/SearchContext';
import MakeModelDropdown from './MakeModelDropdown';
import NicknameModal from './NicknameModal';
import FeaturedVehicles from './FeaturedVehicles';
import ImportedVehicles from './ImportedVehicles';
import Chatbot from './ChatBot';
import AdSenseAd from './AdSenseAd';
import { showAlert } from '../utils/AlertUtills';
import { TimestampToDate } from '../utils/DateAndTimeUtils';
import axios from 'axios';
import DiscountIcon from '@mui/icons-material/Discount';
import MultiSearch from './MultiSearch';
import DriveEtaIcon from '@mui/icons-material/DriveEta';

function HeroSection() {
  const { expiredClaims = [] } = useContext(GlobalContext);
  const { recaptchaToken, setRecaptchaToken, userID, user } =
    useContext(UserContext);
  const { expiredClaimModalShown, setExpiredClaimModalShown } =
    useContext(VehicleDataContext);
  const {
    selectedMake,
    setSelectedMake,
    selectedModel,
    setSelectedModel
  } = useContext(SearchContext);

  const navigate = useNavigate();
  const location = useLocation();

  const [modelMessage, setModelMessage] = useState('');
  const [showFalse, setShowFalse] = useState(false);
  const [isWidgetVisible, setIsWidgetVisible] = useState(true);
  const [plateNumberOrVIN, setPlateNumberOrVIN] = useState('');
  const [makeArray, setMakeArray] = useState([]);
  const [modelArray, setModelArray] = useState([]);
  const [passPromotions, setPassPromotions] = useState([]);
  const [featuredDealer, setFeaturedDealer] = useState(null);

  const punctuationRegex =
    /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
  const turnstileSiteKey =
    process.env.NODE_ENV === 'production'
      ? '0x4AAAAAAACzw6hd6iqcTkiE'
      : '1x00000000000000000000AA';

  const handleCloseFalse = () => {
    setShowFalse(false);
  };

  useEffect(() => {
    if (
      expiredClaims.length > 0 &&
      expiredClaimModalShown === 'false'
    ) {
      setModelMessage('Claim expired..! Please reclaim');
      setShowFalse(true);
    }
  }, [expiredClaims, expiredClaimModalShown]);

  async function dataSend(e) {
    e.preventDefault();

    if (plateNumberOrVIN) {
      if (
        plateNumberOrVIN.length > 17 ||
        plateNumberOrVIN.length < 4
      ) {
        await showAlert(
          'error',
          '',
          'Invalid Plate Number or VIN!'
        );
      } else if (punctuationRegex.test(plateNumberOrVIN)) {
        await showAlert(
          'error',
          '',
          'Invalid Plate Number or VIN!'
        );
      } else {
        navigate('/details', {
          state: { plateNumberOrVIN }
        });
      }
    } else {
      navigate('/advancedSearch', {
        state: { fetchdata: true }
      });
    }
  }

  useEffect(() => {
    const fetchMakeModel = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SEARCH_API}getmakesmodelsorcombination`,
          {}
        );

        const makes = response.data?.makes || [];
        const models = response.data?.models || [];

        setMakeArray(makes.map(item => item.make));
        setModelArray(models.map(item => item.model));
      } catch (error) {
        console.error('Error fetching makes/models:', error);
      }
    };

    fetchMakeModel();
  }, []);

  useEffect(() => {
    const fetchPassPromotions = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_COMMON}passPromotions`
        );

        setPassPromotions(response.data || []);
      } catch (error) {
        console.error('Error fetching promotions:', error);
      }
    };

    fetchPassPromotions();
  }, []);

  useEffect(() => {
    const handleNavigation = async () => {
      const queryParameters = new URLSearchParams(
        location.search
      );

      let plateNumberOrVIN = null;
      let plateOrVINKey = null;

      if (
        queryParameters.has('plate') ||
        queryParameters.has('vin')
      ) {
        plateOrVINKey = queryParameters.has('plate')
          ? 'plate'
          : 'vin';

        plateNumberOrVIN =
          queryParameters.get(plateOrVINKey);
      }

      if (
        queryParameters.has('payment') &&
        queryParameters.has('vin')
      ) {
        const paymentStatus =
          queryParameters.get('payment');

        if (paymentStatus === 'success') {
          const result = await showAlert(
            'success',
            '',
            'Payment successful'
          );

          if (result.isConfirmed) {
            navigate('/details', {
              state: { plateNumberOrVIN }
            });
          }

          return;
        }

        if (paymentStatus === 'canceled') {
          await showAlert(
            'error',
            '',
            'Payment unsuccessful'
          );

          navigate('/details', {
            state: { plateNumberOrVIN }
          });

          return;
        }
      }

      if (plateOrVINKey) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API_COMMON}getvehicledetailsbyplateorvin`,
            { plateNumberOrVIN }
          );

          if (response.data) {
            navigate('/details', {
              state: { plateNumberOrVIN }
            });
          }
        } catch (error) {
          console.error('Error fetching vehicle:', error);

          if (error.response?.status === 404) {
            await showAlert(
              'error',
              '',
              'Vehicle not found!'
            );
          } else {
            await showAlert(
              'error',
              '',
              'Failed to fetch vehicle details!'
            );
          }

          navigate('/');
        }
      }
    };

    handleNavigation();
  }, [location.search, navigate]);

  function handleCaptchaSuccess(token) {
    setRecaptchaToken(token);
    setIsWidgetVisible(false);
  }

  useEffect(() => {
    window.handleCaptchaSuccess =
      handleCaptchaSuccess;

    return () => {
      delete window.handleCaptchaSuccess;
    };
  }, []);

  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]'
    );

    if (existingScript) {
      return;
    }

    const script = document.createElement('script');

    script.src =
      'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';

    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    const fetchActiveFeaturedDealer = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_COMMON}getActiveFeaturedDealers`,
          {}
        );

        setFeaturedDealer(response.data || null);
      } catch (error) {
        console.error(
          'Error fetching featured dealer:',
          error
        );

        setFeaturedDealer(null);
      }
    };

    fetchActiveFeaturedDealer();
  }, []);

  function handleCardClick() {
    if (!featuredDealer?.TraderNumber) {
      return;
    }

    navigate(
      `/advancedSearch?trader-no=${featuredDealer.TraderNumber}`
    );
  }

  const tickerContent = (
    <>
      {passPromotions?.length > 0 && (
        <>
          <span className="ticker-item ticker-deal">
            <DiscountIcon />
            <strong>DEALS:</strong>
          </span>

          {passPromotions.map((item, index) => (
            <span
              className="ticker-item"
              key={`promotion-${index}`}
            >
              {item.PromotionName}, Free listing
              (limited offer, till{' '}
              {TimestampToDate(item.EndTime)})
            </span>
          ))}

          <span className="ticker-separator">|</span>
        </>
      )}

      {(makeArray?.length > 0 ||
        modelArray?.length > 0) && (
        <span className="ticker-car-icon">
          <DriveEtaIcon />
        </span>
      )}

      {makeArray?.length > 0 && (
        <>
          <span className="ticker-item">
            <strong>MAKES:</strong>
          </span>

          {makeArray.map((item, index) => (
            <span
              className="ticker-item"
              key={`make-${index}`}
            >
              {item}
            </span>
          ))}
        </>
      )}

      {modelArray?.length > 0 && (
        <>
          <span className="ticker-separator">|</span>

          <span className="ticker-item">
            <strong>MODELS:</strong>
          </span>

          {modelArray.map((item, index) => (
            <span
              className="ticker-item"
              key={`model-${index}`}
            >
              {item}
            </span>
          ))}
        </>
      )}
    </>
  );

  return (
    <div className="waka-home">
      <p
        className="BlkWhite marketplace-scroll-bar"
        style={{
          backgroundColor: 'black',
          color: 'white',
          textAlign: 'center'
        }}
      >
        <span className="ticker-window">
          <span className="ticker-track">
            <span className="ticker-sequence">
              {tickerContent}
            </span>

            <span
              className="ticker-sequence"
              aria-hidden="true"
            >
              {tickerContent}
            </span>
          </span>
        </span>
      </p>

      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <span className="hero-badge">
              🇳🇿 NZ's Trusted Car Marketplace
            </span>

            <h1>
              Find Your Perfect Car
              <span> in New Zealand</span>
            </h1>

            <p className="hero-description">
              Discover quality vehicles with confidence.
              Search cars, check vehicle history and
              connect with trusted sellers across New Zealand.
            </p>

            <div className="hero-features">
              <div className="hero-feature">
                <div className="feature-icon">✓</div>

                <div>
                  <strong>Safety Reports</strong>
                  <small>Vehicle history checks</small>
                </div>
              </div>

              <div className="hero-feature">
                <div className="feature-icon">✓</div>

                <div>
                  <strong>Trusted Vehicles</strong>
                  <small>Detailed vehicle information</small>
                </div>
              </div>

              <div className="hero-feature">
                <div className="feature-icon">✓</div>

                <div>
                  <strong>Insurance Benefits</strong>
                  <small>Up to $100 discount</small>
                </div>
              </div>
            </div>
          </div>

          <div className="hero-image-container">
            <div className="hero-image-glow"></div>

            <img
              src={require('../assets/img/photo-2.avif')}
              alt="Car for sale"
              className="hero-car-image"
            />

            <div className="hero-floating-card">
              <div className="floating-icon">🚗</div>

              <div>
                <strong>Search with confidence</strong>
                <span>Verified vehicle information</span>
              </div>
            </div>
          </div>
        </div>

        <div className="vehicle-search-card">
          <div className="search-header">
            <div>
              <h2>Find a Vehicle</h2>

              <p>
                Search by registration, VIN or choose a vehicle
              </p>
            </div>
          </div>

          <form onSubmit={dataSend}>
            <div className="search-controls">
              <div className="search-field vin-field">
                <span className="search-field-icon">
                  🔎
                </span>

                <input
                  type="text"
                  name="plateNumberOrVIN"
                  placeholder="Enter Plate Number or VIN"
                  value={plateNumberOrVIN}
                  onChange={e =>
                    setPlateNumberOrVIN(e.target.value)
                  }
                  disabled={
                    !recaptchaToken ||
                    selectedMake ||
                    selectedModel
                  }
                />
              </div>

              <div className="search-or">
                OR
              </div>

              <div className="search-dropdown">
                <MakeModelDropdown
                  selectedMake={selectedMake}
                  setSelectedMake={make => {
                    setSelectedMake(make);
                  }}
                  selectedModel={selectedModel}
                  setSelectedModel={model => {
                    setSelectedModel(model);
                  }}
                  disabled={
                    !recaptchaToken ||
                    plateNumberOrVIN.length > 0
                  }
                />
              </div>

              <button
                type="submit"
                className="modern-search-button"
              >
                <i className="fas fa-search"></i>
                Search Vehicles
              </button>
            </div>

            {isWidgetVisible && (
              <div className="turnstile-container">
                <div
                  className="cf-turnstile"
                  data-sitekey={turnstileSiteKey}
                  data-callback="handleCaptchaSuccess"
                ></div>
              </div>
            )}

            <div className="search-security">
              🔒 Your information is secure and private
            </div>
          </form>
        </div>

        <MultiSearch />
      </section>

      <section className="quick-check-section">
        <div className="section-container">
          <div className="section-heading">
            <div>
              <span className="section-eyebrow">
                VEHICLE INFORMATION
              </span>

              <h2>
                Everything you need to buy with confidence
              </h2>
            </div>
          </div>

          <div className="quick-check-grid">
            <div className="quick-check-card">
              <div className="quick-icon red">
                🚗
              </div>

              <div>
                <h3>Stolen Vehicle Check</h3>

                <p>
                  Check whether a vehicle has been reported
                  stolen.
                </p>
              </div>

              <span className="arrow">→</span>
            </div>

            <div className="quick-check-card">
              <div className="quick-icon blue">
                📋
              </div>

              <div>
                <h3>Import History</h3>

                <p>
                  Review imported vehicle and damage
                  information.
                </p>
              </div>

              <span className="arrow">→</span>
            </div>

            <div className="quick-check-card">
              <div className="quick-icon green">
                🛡️
              </div>

              <div>
                <h3>Recall Status</h3>

                <p>
                  Check important recall information for
                  vehicles.
                </p>
              </div>

              <span className="arrow">→</span>
            </div>

            <div className="quick-check-card">
              <div className="quick-icon purple">
                💰
              </div>

              <div>
                <h3>Insurance Discount</h3>

                <p>
                  Get up to $100 insurance discount through
                  Cove.
                </p>
              </div>

              <span className="arrow">→</span>
            </div>
          </div>
        </div>
      </section>

      {featuredDealer && (
        <section className="dealer-section">
          <div className="section-container">
            <div className="section-title-row">
              <div>
                <span className="section-eyebrow">
                  TRUSTED SELLERS
                </span>

                <h2>Featured Dealer</h2>

                <p>
                  Explore vehicles from our featured dealer.
                </p>
              </div>

              <button
                className="view-all-button"
                onClick={handleCardClick}
              >
                View Dealer →
              </button>
            </div>

            <div
              className="featured-dealer-card"
              onClick={handleCardClick}
            >
              <div className="dealer-logo-container">
                {featuredDealer.LogoURL && (
                  <img
                    src={featuredDealer.LogoURL}
                    alt={
                      featuredDealer.CompanyName ||
                      'Featured Dealer'
                    }
                  />
                )}
              </div>

              <div className="dealer-info">
                <span>FEATURED DEALER</span>

                <h3>
                  {featuredDealer.CompanyName}
                </h3>

                <p>
                  View available vehicles from this dealer
                </p>
              </div>

              <div className="dealer-arrow">
                →
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="vehicle-section featured-vehicle-section">
        <div className="section-container">
          <div className="section-title-row">
            <div>
              <span className="section-eyebrow">
                HAND PICKED FOR YOU
              </span>

              <h2>Featured Vehicles</h2>

              <p>
                Explore some of the latest vehicles available
                on Waka Online NZ.
              </p>
            </div>

            <button
              className="view-all-button"
              onClick={() => navigate('/advancedSearch')}
            >
              View All Vehicles →
            </button>
          </div>

          <div className="vehicle-component-wrapper">
            <FeaturedVehicles />
          </div>
        </div>
      </section>

      <section className="vehicle-section imported-vehicle-section">
        <div className="section-container">
          <div className="section-title-row">
            <div>
              <span className="section-eyebrow">
                IMPORTED COLLECTION
              </span>

              <h2>Imported Vehicles</h2>

              <p>
                Discover quality imported vehicles available
                through our marketplace.
              </p>
            </div>

            <button
              className="view-all-button"
              onClick={() => navigate('/advancedSearch')}
            >
              Explore Imports →
            </button>
          </div>

          <div className="vehicle-component-wrapper">
            <ImportedVehicles />
          </div>

          <div className="homepage-ad-container">
            <AdSenseAd adSlot="4649286510" />
          </div>
        </div>
      </section>

      <section className="why-waka-section">
        <div className="section-container">
          <div className="why-waka-content">
            <div className="why-waka-text">
              <span className="section-eyebrow">
                WHY WAKA ONLINE NZ
              </span>

              <h2>
                A smarter way to buy and sell vehicles
              </h2>

              <p>
                We make the vehicle buying experience simpler,
                safer and more transparent for buyers and
                sellers across New Zealand.
              </p>

              <div className="why-list">
                <div>
                  <span>✓</span>

                  <strong>
                    Comprehensive vehicle information
                  </strong>
                </div>

                <div>
                  <span>✓</span>

                  <strong>
                    Safety and recall checks
                  </strong>
                </div>

                <div>
                  <span>✓</span>

                  <strong>
                    Trusted dealers and sellers
                  </strong>
                </div>

                <div>
                  <span>✓</span>

                  <strong>
                    Cost-effective vehicle listings
                  </strong>
                </div>
              </div>
            </div>

            <div className="why-waka-card">
              <div className="why-card-icon">
                🛡️
              </div>

              <h3>Buy with confidence</h3>

              <p>
                Get the information you need before making
                your next vehicle decision.
              </p>

              <button
                onClick={() => navigate('/advancedSearch')}
              >
                Start Searching →
              </button>
            </div>
          </div>
        </div>
      </section>

      <div className="social-icons">
        <a
          href="https://www.facebook.com/wakaonlinenz"
          target="_blank"
          rel="noreferrer"
          className="social-icon"
        >
          <i className="fab fa-facebook-f"></i>
        </a>

        <a
          href="https://twitter.com/wakaonlinenz"
          target="_blank"
          rel="noreferrer"
          className="social-icon"
        >
          <i className="fab fa-twitter"></i>
        </a>

        <a
          href="https://www.linkedin.com/company/wakaonlinenz/"
          target="_blank"
          rel="noreferrer"
          className="social-icon"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>

        <a
          href="https://www.youtube.com/channel/UCLy-5NbaUWzFveI_IIuLFug"
          target="_blank"
          rel="noreferrer"
          className="social-icon"
        >
          <i className="fab fa-youtube"></i>
        </a>
      </div>

      <Modal
        show={showFalse}
        onHide={() => {
          handleCloseFalse();
          setExpiredClaimModalShown('true');
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modelMessage}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <table className="expired-claims-table">
            <tbody>
              <tr>
                <th>
                  Vehicle plate or VIN numbers
                </th>
              </tr>

              {expiredClaims.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.PlateNumber || item.VIN}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              handleCloseFalse();
              setExpiredClaimModalShown('true');
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <NicknameModal
        userID={userID}
        nickname={user}
      />

      <Chatbot />
    </div>
  );
}

export default HeroSection;